import { render, staticRenderFns } from "./RightArrowIcon.vue?vue&type=template&id=afbf6446"
import script from "./right-arrow-icon.ts?vue&type=script&lang=ts&external"
export * from "./right-arrow-icon.ts?vue&type=script&lang=ts&external"
import style0 from "./right-arrow-icon.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports